import MailSupport from '../misc/MailSupport'
import React from 'react'

export default function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>
      <p>Last updated: April 5, 2026</p>
      <p>This Privacy Policy describes how We collect, use, disclose, and retain information when You use World Cup Bracket Challenge.</p>

      <h2>Overview</h2>
      <p>We collect information needed to operate the Service, authenticate users, save brackets and pools, display leaderboards, respond to support requests, monitor performance, and improve the product.</p>

      <h2>Information We Collect</h2>
      <h3>Information You Provide</h3>
      <p>Depending on how You use the Service, We may collect:</p>
      <ul>
        <li>Email address</li>
        <li>Phone number, if You choose to provide one</li>
        <li>Bracket names, pool names, and bracket picks</li>
        <li>Messages or support requests You send to Us</li>
      </ul>

      <h3>Authentication Information</h3>
      <p>Sign-in for the Service is handled through Auth0. When You authenticate, We may receive identifiers and profile information associated with Your account, such as Your Auth0 subject identifier and email address.</p>

      <h3>Usage and Device Information</h3>
      <p>We automatically collect certain usage and device information, such as IP address, browser type, pages visited, timestamps, approximate device information, and diagnostic data related to use of the Service.</p>

      <h3>Cookies and Similar Technologies</h3>
      <p>We use cookies and similar technologies for essential site operation, authentication, analytics, remembering preferences, and, when enabled, advertising. Some features of the Service may not function properly if cookies are disabled.</p>

      <h2>How We Use Information</h2>
      <p>We use personal information to:</p>
      <ul>
        <li>Authenticate You and maintain Your account</li>
        <li>Save, display, and score brackets and pools</li>
        <li>Operate leaderboards and pool administration features</li>
        <li>Provide support and respond to inquiries</li>
        <li>Monitor reliability, diagnose issues, and improve the Service</li>
        <li>Protect the Service against misuse, fraud, and security issues</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2>What Other Users Can See</h2>
      <p>If You create or join a pool, other users in that pool may be able to see information associated with Your participation, including Your bracket name, picks, score, ranking, and pool-related details.</p>
      <p>Pool administrators may also be able to view participant contact information that is provided for pool operation, such as email address and any phone number You choose to provide.</p>

      <h2>How We Share Information</h2>
      <p>We may share information with:</p>
      <ul>
        <li><strong>Authentication providers</strong>, including Auth0, to manage sign-in and identity-related operations</li>
        <li><strong>Analytics and diagnostics providers</strong>, including LogRocket, to help Us understand errors, product usage, and performance</li>
        <li><strong>Advertising providers</strong>, when ads are enabled on the Service</li>
        <li><strong>Service providers</strong> that host or support the Service</li>
        <li><strong>Authorities or other parties</strong> when required by law or when reasonably necessary to protect the rights, safety, or security of the Service, its users, or others</li>
      </ul>
      <p>We do not sell Your personal information in the ordinary meaning of the word &quot;sell.&quot; If advertising or analytics technology used on the Service is treated as a &quot;sale&quot; or &quot;sharing&quot; under applicable privacy law, You may contact Us to request more information or exercise applicable rights.</p>

      <h2>Retention</h2>
      <p>We retain personal information for as long as reasonably necessary to operate the Service, maintain brackets and pools, comply with legal obligations, resolve disputes, and enforce agreements. We may retain some information for a longer period when required or permitted by law.</p>

      <h2>Security</h2>
      <p>We use reasonable administrative, technical, and organizational measures designed to protect personal information. No method of transmission or storage is completely secure, so We cannot guarantee absolute security.</p>

      <h2>Your Choices and Rights</h2>
      <p>You may contact Us to request access to, correction of, or deletion of personal information We maintain about You, subject to legal and operational limitations. If deleting certain information would prevent Us from operating an active bracket, pool, or leaderboard entry, We may need to retain some records as permitted by law.</p>
      <p>You can also manage some information by changing the content You submit to the Service or by choosing not to provide optional information such as a phone number.</p>

      <h2>GDPR and Similar Privacy Rights</h2>
      <p>If You are located in a jurisdiction that provides data protection rights, such as the European Economic Area or United Kingdom, You may have rights to access, correct, delete, restrict, or object to certain processing of Your personal information, and to request data portability where applicable. You may exercise those rights by contacting Us.</p>

      <h2>California Privacy Rights</h2>
      <p>If You are a California resident, You may have rights under California privacy law, including rights to know, access, correct, delete, and opt out of certain uses or disclosures of personal information. You may exercise those rights by contacting Us at the email address below.</p>

      <h2>Children&apos;s Privacy</h2>
      <p>The Service is not intended for children under 18, and We do not knowingly collect personal information from children.</p>

      <h2>Third-Party Links</h2>
      <p>The Service may contain links to third-party websites or services. We are not responsible for the privacy practices of those third parties.</p>

      <h2>Changes to this Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. If We make material changes, We will post the updated policy on this page and update the &quot;Last updated&quot; date above.</p>

      <h2>Contact Us</h2>
      <p>If You have any questions about this Privacy Policy or want to make a privacy-related request, You can contact Us at <MailSupport />.</p>
    </div>
  )
}
